import React from 'react';
import { Check, Gift } from 'lucide-react';
export function IncludesSection() {
  const features = ['Cómo funciona el Sistema 2×25 (Domingo + Miércoles)', 'Tu lista corta de ingredientes que se repiten (ahorra dinero)', 'La Matriz de Combos (para no aburrirte y no planear)', 'Tabla de tiempos/temperaturas de freidora de aire + reglas anti-sequedad', 'Mini-Prep Domingo paso a paso (con cronómetro)', 'Mini-Prep Miércoles paso a paso (para salvar la semana)', 'Menú de 21 días (estructura completa)', '3 listas del súper (semanales) + sustituciones baratas', 'Plan B de 7 minutos (cuando el día te gane)', 'Cómo comer con niños sin cocinar doble', 'Tracker imprimible 21 días'];
  return <section className="py-20 px-4 bg-[#F2F1EE]" data-id="element-72">
      <div className="max-w-4xl mx-auto" data-id="element-73">
        <div className="text-center mb-12" data-id="element-74">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-4" data-id="element-75">
            ¿Qué incluye exactamente el PDF?
          </h2>
          <p className="text-lg text-charcoal-light" data-id="element-76">
            Freidora de Aire: Plan 21 Días Alta Proteína (70–90 páginas aprox.)
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-sm border border-cream p-8 md:p-12" data-id="element-77">
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-78">
            {features.map((feature, index) => <div key={index} className="flex items-start gap-3" data-id="element-79">
                <div className="mt-1 min-w-[20px]" data-id="element-80">
                  <Check className="w-5 h-5 text-olive" data-id="element-81" />
                </div>
                <span className="text-charcoal leading-relaxed" data-id="element-82">{feature}</span>
              </div>)}
          </div>

          <div className="mt-12 pt-8 border-t border-cream-dark" data-id="element-83">
            <div className="flex flex-col md:flex-row items-center gap-6 bg-terracotta/5 p-6 rounded-xl border border-terracotta/20" data-id="element-84">
              <div className="bg-terracotta/10 p-4 rounded-full text-terracotta" data-id="element-85">
                <Gift className="w-8 h-8" data-id="element-86" />
              </div>
              <div className="text-center md:text-left" data-id="element-87">
                <h3 className="text-xl font-serif font-bold mb-1 text-[#DF1189]" data-id="element-88">
                  Bonos Incluidos
                </h3>
                <p className="text-charcoal-light" data-id="element-89">
                  Salsas fit de 3 ingredientes (para que no te sepa triste) +
                  Checklist imprimible Dom/Mié
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}